import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  path = "/",
  image = "https://lacrea.fr/og-image.png",
  type = "website",
  article = null,
}) => {
  const url = `https://lacrea.fr${path}`;
  const fullTitle = path === "/" ? title : `${title} | Lacrea`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Lacrea" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Article-specific */}
      {article && (
        <>
          <meta property="article:published_time" content={article.date} />
          <meta property="article:section" content={article.category} />
        </>
      )}
    </Helmet>
  );
};

export default SEO;
